// import "babel-polyfill"
import Es6Promise from 'es6-promise'
import '@/fonts/iconfont.css'
Es6Promise.polyfill()
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css'; 
Vue.use(Mint);
import App from './App'
import router from './router'
import './assets/css/common.css' 
import store from './store'
import { $axios } from '@/assets/js/$axios'
import { checkUserAuthorize, mlzxcheckLink, infocheckLink } from '@/assets/js/request'
import wx from 'weixin-js-sdk'

import { authority, mlzxAuthority, mlzxNotCheck } from '@/assets/js/NonSilenceUrl'
import urlparam from 'urlparam'
import globalComponents from '@/globalComponents'
import AwesomePicker from 'vue-awesome-picker';
Vue.use(globalComponents)
Vue.use(AwesomePicker);
// import MintUI from 'mint-ui'
// import 'mint-ui/lib/style.css'
// Vue.use(MintUI)


Vue.config.productionTip = false
import './assets/css/common.less';
import './viewport-units-buggyfill-init'

import matchDomainName from '@/assets/js/matchDomainName'

// 全局引入Toast
import './components/tools/Toast/toast.css';
import Toast from './components/tools/Toast/index';
Vue.use(Toast);


// 控制台
import VConsole from 'vconsole/dist/vconsole.min.js' //i
// if (process.env.environment == 'test') {
//   new VConsole(); 
// }
let test = matchDomainName.test();

if (test.flag || window.localStorage.getItem('clickConunt') == 10) {
    // let vconsole = new VConsole();
}


import cookie from 'vue-cookie'
Array.prototype.remove = function (val) {
    let index = this.indexOf(val)
    if (index > -1) {
        this.splice(index, 1)
    }
}

import { GetQueryString } from './assets/js/urlData.js';

function requestCountSilenceJump() {
    let request_count = window.localStorage.getItem('request_count') ? parseInt(window.localStorage.getItem('request_count')) : 0;

    if (request_count >= 5) {
        window.localStorage.setItem('request_count', '0')
        if (typeof window.WeixinJSBridge == "undefined") {
            window.addEventListener('load', () => {
                // WeixinJSBridge.call('closeWindow');
            })
        } else {
            // WeixinJSBridge.call('closeWindow');
        }

        return false;
    }
    window.localStorage.setItem('request_count', request_count + 1)

    //checkUserAuthorize(GetQueryString('orgId')),mlzxcheckLink
    window.location.href = checkUserAuthorize(GetQueryString('orgId')) + window.encodeURIComponent(window.location.href);
}
function requestCountJump() {
    let request_count = parseInt(window.localStorage.getItem('request_count'));
    if (request_count >= 5) {
        window.localStorage.setItem('request_count', '0')
        if (typeof window.WeixinJSBridge == "undefined") {
            window.addEventListener('load', () => {
                // WeixinJSBridge.call('closeWindow');
            })
        } else {
            // WeixinJSBridge.call('closeWindow');
        }

        return false;
    }
    window.localStorage.setItem('request_count', request_count + 1)

    //checkUserAuthorize(GetQueryString('orgId')),mlzxcheckLink
    window.location.href = infocheckLink(GetQueryString('orgId')) + window.encodeURIComponent(window.location.href);
}


let cancel = null;
function getTriggerEventId(to, next) {
    let triggerEventId = to.query.triggerEventId ? to.query.triggerEventId : '';
    if (!triggerEventId) {
        triggerEventId = GetQueryString('triggerEventId') ? GetQueryString('triggerEventId') : '';
    }
    if (triggerEventId) {
        const CancelToken = axios.CancelToken;
        if (cancel) {
          console.log('cancel',new Date().getTime());
          
            cancel();
        }

        setTimeout(() => {
            $axios({
                // cancelToken: source.token
                method: 'POST',
                url: `/mkt/checkplan/${triggerEventId}`,
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancel = c;
                })
            }).then(res => {
                if (res.data.scode === '0') {
                    // Vue.$toast.center("sdsdsds")
                    next();
                    sessionStorage.setItem('triggerEventId', triggerEventId)
                } else {
                    next('/activeEnd');
                    sessionStorage.setItem('triggerErrorMsg', res.data.smsg)
                }
            })

        }, 500)


    }

}


//   to: Route: 即将要进入的目标 路由对象
//   from: Route: 当前导航正要离开的路由
//   next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
// next(): 进行管道中的下一个钩子。如果全部钩子执行完了，则导航的状态就是 confirmed （确认的）。
// next(false): 中断当前的导航。如果浏览器的 URL 改变了（可能是用户手动或者浏览器后退按钮），那么 URL 地址会重置到 from 路由对应的地址。
// next('/') 或者 next({ path: '/' }): 跳转到一个不同的地址。当前的导航被中断，然后进行一个新的导航。
// next(error): (2.4.0+) 如果传入 next 的参数是一个 Error 实例，则导航会被终止且该错误会被传递给 router.onError() 注册过的回调。


// router.afterEach(function(to,form){/*在跳转之后判断*/
//   console.log('afterEach')
//   getTriggerEventId(to,next);
//
//
//
// })
router.beforeEach((to, from, next) => {
    getTriggerEventId(to, next);
    if (process.env.NODE_ENV === 'production') {
        try {
            let member = cookie.get('newmember') ? JSON.parse(cookie.get('newmember')) : null;
            if (
                (
                    !member
                    || (!member.id)
                    || member.id.toString().trim() == ''
                    || (!member.orgId)
                    || member.orgId.toString().trim() == ''
                    || (!member.wxOpenid)
                    || member.wxOpenid.toString().trim() == ''
                    || (!cookie.get('v'))
                    || cookie.get('v').toString().trim() == '')
                || (
                    GetQueryString('orgId') != 2
                    && (GetQueryString('orgId') != member.orgId)
                )
            ) {
                authority().indexOf(to.fullPath) == -1 ? requestCountSilenceJump() : requestCountJump();
                next(false);
                return;
            }


            let needCheck = true;
            if (cookie.get('newmlzx_member')) {
                needCheck = false;
            } else {
                if (mlzxNotCheck().indexOf(to.name) > -1 || (to.name === 'index' && to.path === '/')) {                    
                    needCheck = false;
                }
            } 
            
            //美丽在线云授权
            if (needCheck
                // !cookie.get('newmlzx_member')  

                // (mlzxAuthority().indexOf('/' + to.name) > -1 && !cookie.get('newmlzx_member')) ||

                // GetQueryString('orgId') == 2 && !cookie.get('newmlzx_member')  

                // urlparam('miniopenid') && cookie.get('newmember_staff') && cookie.get('newmember_staff').id
            ) {

                let request_count = parseInt(window.localStorage.getItem('request_count'));
                if (request_count >= 5) {
                    window.localStorage.setItem('request_count', '0')
                    if (typeof window.WeixinJSBridge == "undefined") {
                        window.addEventListener('load', () => {
                            // WeixinJSBridge.call('closeWindow');
                        })
                    } else {
                        // WeixinJSBridge.call('closeWindow');
                    }
                    return false;
                }
                window.localStorage.setItem('request_count', request_count + 1)
                const billUrl = window.location.href.split('#')[0] + '#' + to.fullPath;
                console.log('====mlzxcheckLink====')
                // debugger
                window.location.href = mlzxcheckLink() + window.encodeURIComponent(billUrl);
                next(false);
                return false;

            }


            window.localStorage.setItem('request_count', '0')
            cookie.get('newmember') ? window.localStorage.setItem('member', cookie.get('newmember')) : window.localStorage.removeItem('member')
            cookie.get('newmlzx_member') ? window.localStorage.setItem('mlzx_member', cookie.get('newmlzx_member')) : window.localStorage.removeItem('mlzx_member')
            cookie.get('newmember_staff') ? window.localStorage.setItem('member_staff', cookie.get('newmember_staff')) : window.localStorage.removeItem('member_staff')
            next();

        } catch (error) {
            alert('授权错误：' + error);
        }


        return;
    } else {
        // let vconsole = new VConsole();
        let _cookie = require('@/util/cookie.js').default;
        let member = {"appellationSex":"女士","b2BCustomerAdmin":false,"currentOrgId":1187,"firstServeOrderId":119881,"id":189895,"isDeleted":0,"mainHeadimgurl":"https://thirdwx.qlogo.cn/mmopen/vi_32/h7G0VS3wZO6Gf1GelwKUQe9QUScKnx1qCqTdOH5GuBPDZLLLDskoJUt1VpOp1kxEPdrm5wQqiappvuvSd7JZ6TQ/132","orgId":1056,"orgName":"福田店","pidSetTime":{"date":20,"day":4,"hours":10,"minutes":40,"month":8,"seconds":33,"time":1537411233000,"timezoneOffset":-480,"year":118},"roles":"","staffId":11073,"status":49,"subscribed":true,"version":786,"wxFirstSubscribeSceneId":0,"wxHeadimgurl":"https://thirdwx.qlogo.cn/mmopen/vi_32/h7G0VS3wZO6Gf1GelwKUQe9QUScKnx1qCqTdOH5GuBPDZLLLDskoJUt1VpOp1kxEPdrm5wQqiappvuvSd7JZ6TQ/132","wxLogonOpenid":"odih71bKmiJ2or0RvJNUzrOceJRM","wxNickname":"多多","wxOpenid":"oABMp07KogCuailaK0JPPkllMCqI","ylkImgUrl":"http://device-img-1251272652.cos.ap-shanghai.myqcloud.com/Ub0000000000116715EJ_0_129845_1421285083_1657828740_1345136225_face_alarm.jpg","ylkUserId":74153942,"zhuziName":"一久净肤嫩肤ÀToi"}

        let member_staff = {"currentOrgId":1187,"haveNoticePermissions":false,"haveSalesPermissions":false,"id":11073,"lastDeviceCode":"b9c5cd636e049421aa677fcd844ac6cc","miniAdmin":false,"miniStatus":721,"miniUserState":1,"miniWxOpenId":"oAjIc5F2SKOH3QRfMZePNTP6SEe8","name":"张恩伟","orgId":1056,"orgName":"福田店","status":49,"topOrgName":"一久净肤嫩肤ÀToi","version":683,"wxHeadImgUrl":"https://thirdwx.qlogo.cn/mmopen/vi_32/h7G0VS3wZO6Gf1GelwKUQe9QUScKnx1qCqTdOH5GuBPDZLLLDskoJUt1VpOp1kxEPdrm5wQqiappvuvSd7JZ6TQ/132","wxOpenid":"oABMp07KogCuailaK0JPPkllMCqI"}
        let userInfo = { "currentOrgId": 2, "id": 234790, "orgId": 2 }
        window.localStorage.setItem('member', JSON.stringify(member))
        window.localStorage.setItem('userInfo', JSON.stringify(userInfo))
        window.localStorage.setItem('member_staff', JSON.stringify(member_staff))
        console.log('/bill', !cookie.get('newmlzx_member'))
        _cookie.set(
            'user_key',
            '251214133032237482'
        )
        _cookie.set(
            'v',
            '1.92109'
        )
        _cookie.set(
            'm_status',
            'true'
        )
        _cookie.set(
            'newmember',
            '%7B%22appellationSex%22%3A%22%E5%A5%B3%E5%A3%AB%22%2C%22b2BCustomerAdmin%22%3Afalse%2C%22currentOrgId%22%3A1187%2C%22firstServeOrderId%22%3A119881%2C%22id%22%3A189895%2C%22isDeleted%22%3A0%2C%22mainHeadimgurl%22%3A%22https%3A%2F%2Fthirdwx.qlogo.cn%2Fmmopen%2Fvi_32%2Fh7G0VS3wZO6Gf1GelwKUQe9QUScKnx1qCqTdOH5GuBPDZLLLDskoJUt1VpOp1kxEPdrm5wQqiappvuvSd7JZ6TQ%2F132%22%2C%22orgId%22%3A1056%2C%22orgName%22%3A%22%E7%A6%8F%E7%94%B0%E5%BA%97%22%2C%22pidSetTime%22%3A%7B%22date%22%3A20%2C%22day%22%3A4%2C%22hours%22%3A10%2C%22minutes%22%3A40%2C%22month%22%3A8%2C%22seconds%22%3A33%2C%22time%22%3A1537411233000%2C%22timezoneOffset%22%3A-480%2C%22year%22%3A118%7D%2C%22roles%22%3A%22%22%2C%22staffId%22%3A11073%2C%22status%22%3A49%2C%22subscribed%22%3Atrue%2C%22version%22%3A786%2C%22wxFirstSubscribeSceneId%22%3A0%2C%22wxHeadimgurl%22%3A%22https%3A%2F%2Fthirdwx.qlogo.cn%2Fmmopen%2Fvi_32%2Fh7G0VS3wZO6Gf1GelwKUQe9QUScKnx1qCqTdOH5GuBPDZLLLDskoJUt1VpOp1kxEPdrm5wQqiappvuvSd7JZ6TQ%2F132%22%2C%22wxLogonOpenid%22%3A%22odih71bKmiJ2or0RvJNUzrOceJRM%22%2C%22wxNickname%22%3A%22%E5%A4%9A%E5%A4%9A%22%2C%22wxOpenid%22%3A%22oABMp07KogCuailaK0JPPkllMCqI%22%2C%22ylkImgUrl%22%3A%22http%3A%2F%2Fdevice-img-1251272652.cos.ap-shanghai.myqcloud.com%2FUb0000000000116715EJ_0_129845_1421285083_1657828740_1345136225_face_alarm.jpg%22%2C%22ylkUserId%22%3A74153942%2C%22zhuziName%22%3A%22%E4%B8%80%E4%B9%85%E5%87%80%E8%82%A4%E5%AB%A9%E8%82%A4%C3%80Toi%22%7D'
        )
        _cookie.set(
            'admin_user',
            'pQ56R4pR9WuB81D%2BBJFlc3W8ccwqJadS78BvktJEHhPuxM%2Bk%2BsMWUdYOlIwQ0mRXSHTdO2T8pokW03M4i50ISnVtI1%2Fz6zU6IiaJib7RiaA8GJYSrPWHH%2FdWhI%2BRqbwmB3Ij1nAq4vgYZgiQLuDCqX8SpPugwSyns7uP6%2BsyCK0iZS0tE9NjS83SBVJu4%2BoTCryVdWjrBgzCl9F%2B39ak6pDmEkwHmueHHZwD8YUgdFAfoPlt3lFrWjJZhL8MtOq2nBt7p1CSWSsG2%2B9nGE692uu6h%2FxsdtpiBGeCZE9qwGoynC8CMPH6%2FCGg4oFPkSIf8zGSP5gOWhhwVsOa2R0v6iK%2Fu9WkwOsCJgJ31hsYi8R5%2BdM2J7Q5dpCgbqFhgslgUSkLq6WemTtT9fO%2BRfrGGTfAvlIaWt8Np8mg51q3dmfIN3D3BI9yUhXBYTvOzf863bXlqsP9%2F6ejBqBhyQsu10DsqZQcQjqqq9hBWsLokLOJmlnOOnuyQNAXomVuIxC54EKDJujl6jYelLgVW4HdxF%2B4r6O8U%2BFu%2BSyWQAc4IU2F%2B8OqVNcPzz1R2FD5aJKwTB2JuLqqnfEijNq%2BPiAnStxVhbjy%2FYLtczT5bUIvmKyooZ5rp3QDmYp67Lvdnm1zeOVZOfzFRRf%2FQU4uS58eyzm3WCFIHNt4B2wGID8MfBigacQHfycmmni2DP4IsRPea7QPhTCwasw%3D'
        )

        _cookie.set(
            'staff_user',
            'cqGvwKTi3lzJxh7KBNBSzcxWOdcYGRG%2BaUXGnUF1By57ENq2F83P3LeG74YU82MREXob%2Bc2J%2ByFEs5QJWaZEMM%2FC2DgceEfKzggupFYWKO1ZSeJ8s7WDZH8QETJizlnb5q9kd%2FXovY9UalsKKp8ZbqAYxvLZWb%2FcDWHSFlbUWdtcMbY5SsXtPPD2EH1aptvyhq4fMF5SWanyMFZjqkBIylM82DokBeoS8Oeyqb9oUbb42ZdMLKYXlWGI%2BTxabcBtUqaxhP1%2FjIeUGIbJ4mwYJ24XSKd%2F6uOlN%2F1HdthuDxtCTvSTHDcX8kW0iUs6FduyDFx5zlftQWbp53ZSxhEZkcgGuHX7XNpa3ERHJTFZZT0TTkyFYIHCBGYAfVMgv8vo3FWmp5dy8yQyfLYGeFpg6T9AH1DtXzEDPaZbkE5%2BjK0b0COi5%2BKyqgI8oai7xiR6X3HpWDbPjp6pvObtYQJ0l0GcWqtskmFQRptohTqGyEyAQlgeN3o7XA%3D%3D'
            )
        _cookie.set(
            's_status',
            'true'
        )
        _cookie.set(
            'newmember_staff',
            '%7B%22currentOrgId%22%3A1187%2C%22haveNoticePermissions%22%3Afalse%2C%22haveSalesPermissions%22%3Afalse%2C%22id%22%3A11073%2C%22lastDeviceCode%22%3A%22b9c5cd636e049421aa677fcd844ac6cc%22%2C%22miniAdmin%22%3Afalse%2C%22miniStatus%22%3A721%2C%22miniUserState%22%3A1%2C%22miniWxOpenId%22%3A%22oAjIc5F2SKOH3QRfMZePNTP6SEe8%22%2C%22name%22%3A%22%E5%BC%A0%E6%81%A9%E4%BC%9F%22%2C%22orgId%22%3A1056%2C%22orgName%22%3A%22%E7%A6%8F%E7%94%B0%E5%BA%97%22%2C%22status%22%3A49%2C%22topOrgName%22%3A%22%E4%B8%80%E4%B9%85%E5%87%80%E8%82%A4%E5%AB%A9%E8%82%A4%C3%80Toi%22%2C%22version%22%3A683%2C%22wxHeadImgUrl%22%3A%22https%3A%2F%2Fthirdwx.qlogo.cn%2Fmmopen%2Fvi_32%2Fh7G0VS3wZO6Gf1GelwKUQe9QUScKnx1qCqTdOH5GuBPDZLLLDskoJUt1VpOp1kxEPdrm5wQqiappvuvSd7JZ6TQ%2F132%22%2C%22wxOpenid%22%3A%22oABMp07KogCuailaK0JPPkllMCqI%22%7D'
            )

        _cookie.set(
            'wap_session_id',
            'dabcbadf-7034-44d0-b495-a4a6b015251c'
        )
        // _cookie.set(
        //     'newmlzx_member',
        //     '%7B%22appellationSex%22%3A%22%E5%A5%B3%E5%A3%AB%22%2C%22b2BCustomerAdmin%22%3Afalse%2C%22id%22%3A234677%2C%22isDeleted%22%3A0%2C%22orgId%22%3A2%2C%22staffId%22%3A-100%2C%22wxFirstSubscribeSceneId%22%3A0%2C%22wxHeadimgurl%22%3A%22https%3A%2F%2Fthirdwx.qlogo.cn%2Fmmopen%2FajNVdqHZLLAr0ibxhDl8UzKdMU7123CfKVdSRPGsrfQWky2VHdVfKhARoicnZMhbiacNArTqRpLV3grXX9G5WBvb6fKdPSVGEEnib2YLicdu83RI%2F132%22%2C%22wxLogonOpenid%22%3A%22oFoAE1iWkYlnrNVi31cdrl2C-Cf4%22%2C%22wxNickname%22%3A%22Rz%F0%9F%90%A0%F0%9F%90%AC%22%2C%22wxOpenid%22%3A%22oFoAE1iWkYlnrNVi31cdrl2C-Cf4%22%2C%22zhuziName%22%3A%22%E7%BE%8E%E4%B8%BD%E5%9C%A8%E7%BA%BF%E4%BA%91%E5%85%88%E8%A1%8C%E7%89%88%22%7D'
        // )


        next();

    }


});


window.vm = new Vue({
    el: '#app',
    router,
    store,
    data: {
      printerId: false,
      timer: null,
      axiosNumberArr: []
    },
    components: {
        App
    },
    created () {
      this.initPath()
    },
    methods: {
      initPath() {
        // this.printerId = require('queryString').parse(location.href.split('?')[1]).printerId
        this.printerId = urlparam('printerId')
        if (this.printerId) {
          this.$router.replace('shoppingSheet')
          setTimeout(() => {
            console.log(this.$router);
          }, 1000);
          
        }
      }
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js